import { Skeleton } from 'antd';
import { Container, Pane, Row, LeftPanes, RightPanes, Title } from './styled';
import { UpgradeLicense } from 'components/common';

function CTA(props) {
  return (
    <>
      <Container style={{ filter: 'blur(2px)' }}>
        <LeftPanes>
          <Pane title=''>
            <Skeleton paragraph={{ rows: 6 }} style={{ marginTop: 5 }} />
          </Pane>
          <Row>
            <Pane title='Session Details'>
              <Skeleton paragraph={{ rows: 6 }} style={{ marginTop: 5 }} />
            </Pane>
            <Pane title='Tradeshow Details'>
              <Skeleton paragraph={{ rows: 6 }} style={{ marginTop: 5 }} />
            </Pane>
          </Row>
        </LeftPanes>
        <RightPanes>
          <Pane>
            <div>
              <Title>Contributors</Title>
              <Skeleton paragraph={{ rows: 6 }} style={{ marginTop: 5 }} />
            </div>
          </Pane>
        </RightPanes>
      </Container>
      <UpgradeLicense />
    </>
  );
}

export default CTA;
